import { render, staticRenderFns } from "./free_order.vue?vue&type=template&id=6ef5251d&"
import script from "./free_order.vue?vue&type=script&lang=js&"
export * from "./free_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports